import React, { createContext, useState, useEffect, useContext, useRef } from "react"
import { getGroupByUser } from "../service/groupService"
import { AuthContext } from "./AuthContext"
import { SessionContext } from "./SessionContext"

export const SelectedGroupContext = createContext()

// After a lookup that found no group, how long to wait before asking again for the same
// session and grouping. SessionContext replaces `session` on every 10 s poll and every
// 'update session' push, and this lookup used to run on each one: in sessions without
// groups (Reasoning Gap, Python without AI chat) every run is a 404 - about a third of all
// requests during a class. A change of session or of its grouping (grouped, group_round)
// still looks again at once; a group an instructor creates by hand (which leaves the session
// row alone) is picked up within this interval.
const NO_GROUP_RECHECK_MS = 60 * 1000

export const SelectedGroupProvider = ({ children }) => {
	const [selectedGroup, setSelectedGroup] = useState(null)
	const [waiting, setWaiting] = useState(false)
	const { currentUser } = useContext(AuthContext)
	const { session } = useContext(SessionContext)
	// The last lookup that found no group: { key, at }.
	const lastMiss = useRef({ key: null, at: 0 })

	useEffect(() => {
		const fetchGroup = async () => {
			if (!selectedGroup && currentUser && session) {
				// skip group fetching for Vizmental sessions
				// since they don't use groups
				if (session.type === 'Vizmental') {
					return
				}
				if (currentUser.role === 3 || currentUser.role === 4) {
					const key = `${currentUser.id}:${session.id}:${session.grouped}:${session.group_round}`
					if (lastMiss.current.key === key && Date.now() - lastMiss.current.at < NO_GROUP_RECHECK_MS) return
					// Recorded before the request, so the copies of `session` that arrive while it
					// is in flight do not start more lookups.
					lastMiss.current = { key, at: Date.now() }
					const group = await getGroupByUser(currentUser.id,session.id)
					console.log('selected', group)
					if (group) {
						lastMiss.current = { key: null, at: 0 }
						setSelectedGroup(group)
					}
				}
			}
		}
		fetchGroup()
	}, [currentUser, session])

	return (
		<SelectedGroupContext.Provider value={{ selectedGroup, setSelectedGroup, waiting, setWaiting }}>
			{children}
		</SelectedGroupContext.Provider>
	)
}
